import React from "react";

const StatusReport = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="m11.258 13.598 3.967 3.988-9.258 9.303H2V22.9l9.258-9.304v.001Zm1.322-1.329 1.983-1.994a.933.933 0 0 1 1.323 0l2.645 2.659a.942.942 0 0 1 0 1.329l-1.984 1.993-3.967-3.987Z"
            fill={fill}
        />
        <rect className="u_fill"
            x={22.09}
            y={12.368}
            width={11.911}
            height={3.42}
            rx={0.379}
            fill={fill}
        />
        <rect className="u_fill"
            x={22.09}
            y={19.916}
            width={11.911}
            height={3.42}
            rx={0.379}
            fill={fill}
        />
    </svg>
);

export default StatusReport;
